"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseControl = /** @class */ (function () {
    function BaseControl() {
    }
    BaseControl.skipProp = ['form', 'parentName', 'field'];
    return BaseControl;
}());
exports.BaseControl = BaseControl;
//# sourceMappingURL=BaseControl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/ui/BaseControl.js
// module id = 20
// module chunks = 0